import React, { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { validatorTypes } from "@data-driven-forms/react-form-renderer";
import FormRenderer, { ComponentMapper, FormTemplate, componentTypes } from "../../../common/FormRenderer";
import { Button } from "react-bootstrap";
import { ACTIONS } from "../../../common/Constants";
import { getValue, preventDefault } from "../../../../utils/common";
import { useCreateAct, useGetLaws, useUpdateAct } from "../../../../backend/masters";
import { EstablishmentTypes, GetActionTitle } from "../Master.constants";
import { toast } from "react-toastify";
import { ERROR_MESSAGES } from "../../../../utils/constants";
import PageLoader from "../../../shared/PageLoader";
import { DEFAULT_OPTIONS_PAYLOAD } from "../../../common/Table";

function AddEditAct({ action, record : data, onClose, onSubmit }: any) {
    const [t] = useState(new Date().getTime());
    const [form, setForm] = useState<any>({});
    const [act, setAct] = useState<any>({ hideButtons: true });
    const { laws, isFetching: loadingLaws } = useGetLaws({ ...DEFAULT_OPTIONS_PAYLOAD, t });

    const { createAct, creating } = useCreateAct((act: any) => {
        if (act && act.error_messages.length > 0) {
            toast.error(act.error_messages.join(', '));
        } else {
            toast.success(`"${act.name}" created successfully.`);
            onSubmit();
        }
    }, errorCallback);


    const { updateAct, updating } = useUpdateAct((act: any) => {
        if (act && act.error_messages.length > 0) {
            toast.error(act.error_messages.join(', '));
        } else {
            toast.success(`"${act.name}" updated successfully.`);
            onSubmit();
        }
    }, errorCallback);

    function errorCallback() {
        toast.error(ERROR_MESSAGES.DEFAULT);
    }

    const schema = {
        fields: [
            {
                component: componentTypes.INPUT_AS_TEXT,
                name: 'name',
                label: 'Act Name',
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                content: getValue(data, 'name')
            },
            {
                component: componentTypes.SELECT,
                name: 'establishment_type',
                label: 'Establishment Type',
                content: action === '',
                options: EstablishmentTypes,
                validate: [
                    { type: validatorTypes.REQUIRED }
                ]
            },
            {
                component: componentTypes.SELECT,
                name: 'law',
                label: 'Law',
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                content: getValue(data, 'law.name'),
                options: laws,
                isLoading: loadingLaws,
            }
        ],
    };

    function debugForm(_form: any) {
        setForm(_form);
        setAct(_form.values);
    }

    function submit(e: any) {
        preventDefault(e);
        if (form.valid) {
            const { name, establishment_type, law } = act;
            const request: any = {
                name: name.trim(),
                law_id: law.value,
                establishment_type: establishment_type.value
            };

            if (action === ACTIONS.EDIT) {
                request['id'] = data.id;
                updateAct(request);
            } else {
                createAct(request);
            }
        }
    }

    useEffect(() => {
        if (data) {
            const { establishment_type, law } = data;
            setAct({
                ...act,
                ...data,
                establishment_type: {
                    value: establishment_type,
                    label: establishment_type
                },
                law: law ? { value: law.id, label: law.name } : null
            });
        }
    }, [data]);

    return (
        <>
            <Modal show={true} backdrop="static" dialogClassName="drawer" animation={false}>
                <Modal.Header closeButton={true} onHide={onClose}>
                    <Modal.Title className="bg">{GetActionTitle('Act', action)}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormRenderer FormTemplate={FormTemplate}
                        initialValues={act}
                        componentMapper={ComponentMapper}
                        schema={schema}
                        debug={debugForm}
                    />
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                    {
                      <>
                          <Button variant="outline-secondary" className="btn btn-outline-secondary px-4" onClick={onClose}>{'Cancel'}</Button>
                          <Button variant="primary" onClick={submit} className="px-4" disabled={!form.valid}>{'Submit'}</Button>
                      </> 

                    }
                </Modal.Footer>
            </Modal>
            {
                (creating || updating) &&
                <PageLoader>
                    {creating ? 'Creating Act...' : 'Updating Act...'}
                </PageLoader>
            }
        </>
    )
}

export default AddEditAct;
